import type { FC, HTMLAttributes, ReactNode } from "react";
import { cn } from "../utilities/cn";
import { textPageDescription, textPageTitle } from "../utilities/layout";

export interface PageHeaderProps
  extends Omit<HTMLAttributes<HTMLDivElement>, "title"> {
  title: ReactNode;
  description?: ReactNode;
  /** Rendered above the title (e.g. back button). */
  leading?: ReactNode;
  /** Hide on small screens when a split/detail panel is open. */
  hiddenWhenSplit?: boolean;
  splitIsOpen?: boolean;
}

/**
 * Standard page title block: optional leading action, title, description.
 */
export const PageHeader: FC<PageHeaderProps> = ({
  title,
  description,
  leading,
  hiddenWhenSplit = false,
  splitIsOpen = false,
  className,
  children,
  ...rest
}) => (
  <div
    className={cn(
      hiddenWhenSplit && splitIsOpen ? "hidden lg:block" : "",
      className,
    )}
    {...rest}
  >
    {leading}
    <h1 className={textPageTitle}>{title}</h1>
    {description ? (
      <p className={textPageDescription}>{description}</p>
    ) : null}
    {children}
  </div>
);
